import { render, staticRenderFns } from "./Covid19Thanks.vue?vue&type=template&id=34a66546"
import script from "./Covid19Thanks.vue?vue&type=script&lang=js"
export * from "./Covid19Thanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports